module.exports = __webpack_public_path__ + "media/images/wines-header-m-00d7330c906c3f1e022decbcd224f3c4.jpg";